import React from 'react';
import { Loader2, Usb } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export const PrinterStatusCard = ({ device, supported, progress, onConnect }) => (
  <Card className={`p-4 ${device ? 'bg-emerald-50 border-emerald-300' : 'bg-amber-50 border-amber-300'}`} data-testid="printer-status-card">
    <div className="flex items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <Usb className={`h-5 w-5 ${device ? 'text-emerald-700' : 'text-amber-700'}`} />
        <div>
          <div className="text-sm font-medium" data-testid="printer-status-text">
            {device ? `Connected: ${device.productName || 'USB Printer'}` : supported ? 'No USB printer connected' : 'WebUSB not supported in this browser — use Chrome/Edge'}
          </div>
          {progress && <div className="text-xs text-stone-600 mt-1 flex items-center gap-1" data-testid="print-progress"><Loader2 className="h-3 w-3 animate-spin" /> {progress}</div>}
        </div>
      </div>
      <Button size="sm" variant={device ? 'outline' : 'default'} onClick={onConnect} disabled={!supported} data-testid="connect-usb-btn">
        <Usb className="h-4 w-4 mr-1" /> {device ? 'Reconnect' : 'Connect USB printer'}
      </Button>
    </div>
  </Card>
);
